const state = {
    auth:          null,
    userLocations: [],
};

const getters = {
    auth:          state => state.auth,
    userLocations: state => state.userLocations,
};

const mutations = {
    SET_AUTH(state, payload) {
        state.auth = payload;
    },
    SET_USER_LOCATIONS(state, payload) {
        state.userLocations = payload;
    },
};

const actions = {
    setAuth({commit}, auth) {
        commit('SET_AUTH', auth);
    },
    setLocations({commit}, userLocations) {
        commit('SET_USER_LOCATIONS', userLocations);
    },
};

export default {
    state,
    actions,
    getters,
    mutations
};
